import { useEffect, useState } from 'react'

import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import { Checkbox } from '../../../../../components/forms/checkbox/checkbox.js'
import { portalGet, portalPut } from '../../../utils/api.js'

interface NotificationSettingsData {
    weeklyDigestOptIn: boolean
}

/**
 * Self-only notification settings panel (rendered inside the "Seaded" tab).
 * Currently a single opt-in: the Friday Slack DM summarising next week's
 * events (TASK-217).
 */
export const NotificationSettings = ({ lang }: { lang: Language }) => {
    const tr = t.portal.profile

    const [weeklyDigest, setWeeklyDigest] = useState<boolean | null>(null)
    const [busy, setBusy] = useState(false)

    useEffect(() => {
        let cancelled = false
        void (async () => {
            const res = await portalGet<NotificationSettingsData>(
                '/api/portal/me/notification-settings',
            )
            if (!cancelled && res.ok) setWeeklyDigest(res.data.weeklyDigestOptIn)
        })()
        return () => {
            cancelled = true
        }
    }, [])

    const handleChange = async (isChecked: boolean) => {
        const previous = weeklyDigest
        setWeeklyDigest(isChecked)
        setBusy(true)
        const res = await portalPut('/api/portal/me/notification-settings', {
            weeklyDigestOptIn: isChecked,
        })
        if (!res.ok) setWeeklyDigest(previous)
        setBusy(false)
    }

    return (
        <Checkbox
            size="small"
            label={tr.settingsWeeklyDigestLabel(lang)}
            isChecked={weeklyDigest === true}
            isDisabled={weeklyDigest === null || busy}
            onChange={(isChecked) => void handleChange(isChecked)}
            note={
                <div className="portal-profile__setting-note">
                    {tr.settingsWeeklyDigestNote(lang)}
                </div>
            }
        />
    )
}
